/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EntryType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18;

export const EntryType = {
    NUMBER_1: 1 as EntryType,
    NUMBER_2: 2 as EntryType,
    NUMBER_3: 3 as EntryType,
    NUMBER_4: 4 as EntryType,
    NUMBER_5: 5 as EntryType,
    NUMBER_6: 6 as EntryType,
    NUMBER_7: 7 as EntryType,
    NUMBER_8: 8 as EntryType,
    NUMBER_9: 9 as EntryType,
    NUMBER_10: 10 as EntryType,
    NUMBER_11: 11 as EntryType,
    NUMBER_12: 12 as EntryType,
    NUMBER_13: 13 as EntryType,
    NUMBER_14: 14 as EntryType,
    NUMBER_15: 15 as EntryType,
    NUMBER_16: 16 as EntryType,
    NUMBER_17: 17 as EntryType,
    NUMBER_18: 18 as EntryType
};

